var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
export var radius = [8, 16, 24, 32];
export var getRadiusByIncomingProps = function (_a) {
    var $radius = _a.$radius, $desktop = _a.$desktop, $mobile = _a.$mobile;
    if ($radius) {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["border-radius: ", "px"], ["border-radius: ", "px"])), $radius);
    }
    else {
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            border-radius: ", "px;\n\n            @media (min-width: ", ") {\n                border-radius: ", "px;\n            }\n        "], ["\n            border-radius: ", "px;\n\n            @media (min-width: ", ") {\n                border-radius: ", "px;\n            }\n        "])), $mobile, wideBreakpoints.mobile, $desktop);
    }
};
var RounderContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n    overflow: hidden;\n"], ["\n    ", ";\n    overflow: hidden;\n"])), getRadiusByIncomingProps);
export var withRadius = function (Component, props) {
    return styled(Component)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        ", ";\n        overflow: hidden;\n    "], ["\n        ", ";\n        overflow: hidden;\n    "])), getRadiusByIncomingProps(props));
};
export default RounderContainer;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
